// REACT
import React from "react";

// ROUTING
import { Link } from "react-router-dom";

// FORMATTING & INTERNATIONALIZATION
import { FormattedMessage } from "react-intl";

// COMPONENTS
import NotificationPriority from "../shared/NotificationPriority";
import NotificationReadStatus from "../shared/NotificationReadStatus";
import NotificationTime from "../shared/NotificationTime";

// STYLES
import styles from "./styles/style.module.scss";

function OrderCreated({ notification, index, icon, link }) {
    return (
        <Link className={styles["notification-template"]} to={link} key={index}>
            <div
                className="notification-wrapper"
                data-notification-read={notification?.read}
            >
                <div className="data-container">
                    <div className="image">
                        <img src={icon} alt="" />
                    </div>
                    <div className="info">
                        <h5>
                            {notification?.title}
                            <NotificationPriority notification={notification} />
                        </h5>
                        <p>
                            <FormattedMessage id="orderWithTrackingNumber" />
                            <b>{notification?.data?.trackingNumber}</b>
                            <FormattedMessage id="hasBeenCreated" />
                        </p>
                        <div className="footer">
                            <span className="carrier">
                                <FormattedMessage id="carrier" />:{" "}
                                {notification?.data?.carrier}
                            </span>
                            <span className="date">
                                <NotificationTime notification={notification} />
                            </span>
                        </div>
                    </div>
                </div>
                <NotificationReadStatus notification={notification} />
            </div>
        </Link>
    );
}

export default OrderCreated;
